var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiTotalCoachesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 16.6668H18.3332V15.0002C18.3331 13.9352 17.6583 12.9872 16.6521 12.6383C15.6459 12.2894 14.5291 12.6163 13.8698 13.4527M14.1665 16.6668H5.83317M14.1665 16.6668V15.0002C14.1665 14.4535 14.0615 13.931 13.8698 13.4527M5.83317 16.6668H1.6665V15.0002C1.66658 13.9352 2.34133 12.9872 3.34755 12.6383C4.35377 12.2894 5.47053 12.6163 6.12984 13.4527M5.83317 16.6668V15.0002C5.83317 14.4535 5.93817 13.931 6.12984 13.4527M6.12984 13.4527C6.76299 11.8704 8.29558 10.8329 9.99984 10.8329C11.7041 10.8329 13.2367 11.8704 13.8698 13.4527M12.4998 5.8335C12.4998 7.21328 11.3796 8.3335 9.99984 8.3335C8.62005 8.3335 7.49984 7.21328 7.49984 5.8335C7.49984 4.45371 8.62005 3.3335 9.99984 3.3335C11.3796 3.3335 12.4998 4.45371 12.4998 5.8335L14.1665 16.6668",
    stroke: "#334155",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiTotalCoachesIcon);
export default __webpack_public_path__ + "static/media/kpi_total_coaches_icon.4435086254233778059a3e435d9c9b6b.svg";
export { ForwardRef as ReactComponent };